import { api } from '@spartalabs/pdc-core';
import { mapLoginResponseToUser } from './portalAuthMapper';

const removesSpecialCharacters = (value: string) => value.replace(/\D/g, '');

/**
 * Overrides pdc-core auth transforms so PDV funcionalidade codigos (e.g.
 * faturamento_acesso) map to portal Permission keys expected by the UI.
 */
api.injectEndpoints({
  overrideExisting: true,
  endpoints: builder => ({
    login: builder.mutation({
      query: ({ username, password }: { username: string; password: string }) => ({
        url: 'api/LoginPdc',
        method: 'post',
        data: { usuario: removesSpecialCharacters(username), senha: password },
      }),
      transformResponse: (response: unknown) =>
        mapLoginResponseToUser(
          response as Parameters<typeof mapLoginResponseToUser>[0],
        ),
    }),
    resetPassword: builder.mutation({
      query: (data: { username: string; pwd: string; newPwd: string }) => ({
        url: 'api/LoginPdc/AlterarSenha',
        method: 'post',
        data: {
          cpf: removesSpecialCharacters(data.username),
          senha: data.pwd,
          novaSenha: data.newPwd,
        },
      }),
      transformResponse: (response: unknown) =>
        mapLoginResponseToUser(
          response as Parameters<typeof mapLoginResponseToUser>[0],
        ),
    }),
    forgotPassword: builder.mutation({
      query: (data: { cpf: string; email: string; birthdate: string }) => ({
        url: 'api/LoginPdc/EsqueciSenha',
        method: 'post',
        data: {
          cpf: removesSpecialCharacters(data.cpf),
          email: data.email.trim(),
          dataNascimento: data.birthdate,
        },
      }),
    }),
  }),
});
